export default {
  addStudentToClass: {
    fieldNames: ['given_name', 'family_name', 'username'],
    autoFocusField: 'given_name',
    onlySubmitChanges: false,
  },
  addStudentToSchool: {
    fieldNames: ['given_name', 'family_name', 'username'],
    autoFocusField: 'given_name',
    onlySubmitChanges: false,
  },
  teacherLogin: {
    fieldNames: ['username', 'password'],
    autoFocusField: null,
    onlySubmitChanges: false,
  },
  studentSchoolCode: {
    fieldNames: ['accessCode'],
    autoFocusField: 'accessCode',
    onlySubmitChanges: false,
  },
  studentLogin: {
    fieldNames: ['username'],
    autoFocusField: null,
    onlySubmitChanges: false,
  },
  loginAgain: {
    fieldNames: ['password'],
    autoFocusField: null,
    onlySubmitChanges: false,
  },
  createClass: {
    fieldNames: ['className'],
    autoFocusField: null,
    onlySubmitChanges: false,
  },
  acceptTeacherInvitation: {
    fieldNames: [
      'given_name',
      'family_name',
      'username',
      'password',
      'tipsTricks',
      'acceptTerms',
    ],
    autoFocusField: 'given_name',
    onlySubmitChanges: false,
  },
  freeTrial: {
    fieldNames: [
      'given_name',
      'family_name',
      'username',
      'password',
      'schoolName',
      'tipsTricks',
      'acceptTerms',
    ],
    autoFocusField: 'given_name',
    onlySubmitChanges: false,
  },
  createAccount: {
    fieldNames: [
      'given_name',
      'family_name',
      'username',
      'password',
      'schoolName',
      'tipsTricks',
      'acceptTerms',
    ],
    onlySubmitChanges: false,
  },
  accountBasics: {
    fieldNames: ['given_name', 'family_name', 'username', 'schoolName', 'role'],
    autoFocusField: 'given_name',
    onlySubmitChanges: true,
    fieldGroups: [
      {
        title: 'Information',
        keys: ['given_name', 'family_name', 'username'],
      },
      {
        keys: ['schoolName', 'role'],
      },
    ],
  },
  editTeacher: {
    fieldNames: ['given_name', 'family_name', 'username', 'role'],
    autoFocusField: 'given_name',
    onlySubmitChanges: true,
    fieldGroups: [
      {
        keys: ['given_name', 'family_name', 'username', 'role'],
      },
    ],
  },
  editStudent: {
    fieldNames: ['given_name', 'family_name', 'username'],
    autoFocusField: 'given_name',
    onlySubmitChanges: true,
    fieldGroups: [
      {
        keys: ['given_name', 'family_name', 'username'],
      },
    ],
  },
  forgotPassword: {
    fieldNames: ['username'],
    autoFocusField: 'username',
    onlySubmitChanges: false,
  },
  resetPassword: {
    fieldNames: ['password'],
    autoFocusField: 'password',
    onlySubmitChanges: false,
  },
  changePassword: {
    fieldNames: ['currentPassword', 'newPassword', 'newPasswordAgain'],
    autoFocusField: 'currentPassword',
    onlySubmitChanges: false,
    fieldGroups: [
      {
        keys: ['currentPassword'],
      },
      {
        keys: ['newPassword', 'newPasswordAgain'],
      },
    ],
  },
  inviteMultipleTeachers: {
    fieldNames: ['inviteList'],
    autoFocusField: 'inviteList',
    onlySubmitChanges: false,
  },
  inviteSingleTeacher: {
    fieldNames: ['username'],
    autoFocusField: null,
    onlySubmitChanges: false,
  },
  subscriptionPurchase: {
    fieldNames: [
      'cardholders_name',
      'credit_card',
      'billing_email',
      'billing_phone',
    ],
    autoFocusField: null,
    fieldGroups: [
      {
        keys: ['cardholders_name', 'credit_card'],
      },
      {
        id: 'billing-contact',
        hiddenOnMount: true,
        keys: ['billing_email', 'billing_phone'],
      },
    ],
  },
  addPaymentMethod: {
    fieldNames: ['cardholders_name', 'credit_card'],
    autoFocusField: null,
    fieldGroups: [
      {
        keys: ['cardholders_name', 'credit_card'],
      },
    ],
  },
  paymentUsername: {
    fieldNames: ['username'],
    autoFocusField: 'username',
    onlySubmitChanges: false,
  },
};
